import Notification from '@freckle/classroom/ts/common/components/notifications-wrapper/paywall-notification/notification'
import {QuoteRequestModal} from '@freckle/classroom/ts/common/components/quote-request-modal'
import type {PaywallNotificationTypeT} from '@freckle/classroom/ts/common/helpers/paywall-notification'
import {clearNotification} from '@freckle/classroom/ts/common/helpers/paywall-notification'
import {useModal} from '@freckle/classroom/ts/hooks/use-modal'

type Props = {
  notification: PaywallNotificationTypeT | null | undefined
}

export function PaywallNotification(props: Props) {
  const {notification} = props

  const modal = useModal()
  function onCtaClicked() {
    modal.show()
  }

  const notificationComponent =
    notification !== undefined && notification !== null ? (
      <Notification
        notificationType={notification}
        removeNotification={clearNotification}
        onCtaClicked={onCtaClicked}
      />
    ) : null

  return (
    <>
      {notificationComponent}
      <QuoteRequestModal {...modal.props} />
    </>
  )
}
